module.exports = __webpack_public_path__ + "static/media/isdoctorplan-ent3@2x.70f7a858.png";